import AutoDismissFlag from '@atlaskit/flag/auto-dismiss-flag';
import FlagGroup from '@atlaskit/flag/flag-group';
import SuccessIcon from '@atlaskit/icon/core/status-success';
import { token } from '@atlaskit/tokens';
import { FormattedMessage } from 'react-intl';

type ReminderConfirmationFlagProps = {
	onDismissed: () => void;
};

export const ReminderConfirmationFlag = ({
	onDismissed,
}: ReminderConfirmationFlagProps): JSX.Element => (
	<FlagGroup>
		<AutoDismissFlag
			id="loom-meeting-nudge-reminder-confirmation"
			icon={<SuccessIcon label="" color={token('color.icon.success')} spacing="spacious" />}
			title={
				<FormattedMessage
					id="post-office.twc-loom-meeting-nudge-sidenav.reminder-confirmation.title"
					defaultMessage="We’ll remind you again later"
					description="Title confirming that the Loom calendar connection reminder was deferred"
				/>
			}
			description={
				<FormattedMessage
					id="post-office.twc-loom-meeting-nudge-sidenav.reminder-confirmation.description"
					defaultMessage="After you finish your doc, we’ll remind you to connect your calendar to Loom."
					description="Description explaining when the deferred Loom reminder will return"
				/>
			}
			onDismissed={onDismissed}
		/>
	</FlagGroup>
);
